<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        정책
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Policy</a>
          </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>정책</strong>
              <small>사이트 점검시 상세 옵션 설정</small>
              <small class="float-right">{{model.created_at | datetime}}</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="8">
              <b-form-group v-if="model && model.policy">
                <label for="ph_policy" v-b-tooltip.hover>정책 설명
                </label>
                <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="페이지 내에서 탐색하려면 최대 하위 링크를 입력합니다. 초과 링크는 점검하지 않으며 일반적으로 한 페이지에 너무 많은 링크가 있는 경우, 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하여 균형 있게 점검되지 못할 수 있습니다. 1-1,000 범위 내에서 지정할 수 있습니다">서브페이지 링크
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="검사 사이트에서 확인할 총 페이지 수입니다. 입력한 수에 도달하면 점검을 종료합니다. 값은 1부터 라이센스 제한 범위 내에서 자유롭게 지정할 수 있습니다.">최대 탐색 페이지
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="첫 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 1-100 범위 내에서 지정할 수 있습니다">최대 경로 깊이
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="페이지 로딩 대기 시간은 1~30 범위 내에서 지정할 수 있습니다">타임아웃(초)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="새 페이지로 이동하기 전에 기다려야 할 시간입니다. 1 ~ 10,000 범위 내에서 지정할 수 있습니다">점검 속도(밀리 초)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되살리기 </b-button> -->
              <span>삭제된 정책.</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
              <b-button size="sm" variant="danger" @click="remove"> 삭제 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 저장 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
        </b-card>
        <hr>
        <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
